import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
//@ts-nocheck
import MuiMenu from "@mui/material/Menu";
import { withStyles } from "@mui/styles";
import * as React from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  menuContainer: {
    outline: "none"
  },
  verticalAlign: {
    top: "50%",
    transform: "translateY(-50%)",
    position: "relative"
  },
  paper: {
    padding: "8px 0",
    borderRadius: "8px"
  }
};
var Menu = /*#__PURE__*/function (_React$Component) {
  function Menu() {
    var _context;
    var _this;
    _classCallCheck(this, Menu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Menu, _concatInstanceProperty(_context = []).call(_context, args));
    _defineProperty(_this, "state", {
      anchorEl: null
    });
    _defineProperty(_this, "handleOpen", function (event) {
      event.stopPropagation();
      if (!_this.props.disabled) {
        _this.setState({
          anchorEl: event.currentTarget
        });
      }
    });
    _defineProperty(_this, "handleClose", function (vars) {
      vars.stopPropagation();
      _this.setState({
        anchorEl: null
      });
      if (_this.props.onClose) _this.props.onClose(vars);
    });
    return _this;
  }
  _inherits(Menu, _React$Component);
  return _createClass(Menu, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _context2;
      var DEFAULT_RENDERER = function DEFAULT_RENDERER() {
        return /*#__PURE__*/_jsx("span", {
          onClick: _this2.handleOpen,
          className: _this2.props.verticalAlign ? classes.verticalAlign : "",
          children: _this2.props.toggleComponent
        });
      };
      var anchorEl = this.state.anchorEl;
      var _this$props = this.props,
        _this$props$renderTog = _this$props.renderToggle,
        renderToggle = _this$props$renderTog === void 0 ? DEFAULT_RENDERER : _this$props$renderTog,
        children = _this$props.children,
        classes = _this$props.classes,
        className = _this$props.className,
        MenuListProps = _this$props.MenuListProps,
        keepOpenOnClick = _this$props.keepOpenOnClick;
      var open = Boolean(anchorEl);
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [renderToggle({
          handleOpenClick: this.handleOpen,
          handleCloseClick: this.handleClose,
          isOpen: open
        }), /*#__PURE__*/_jsx(MuiMenu, {
          classes: {
            paper: _concatInstanceProperty(_context2 = "".concat(classes.paper, " ")).call(_context2, className || "")
          },
          anchorEl: anchorEl,
          open: open,
          onClose: this.handleClose,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          MenuListProps: MenuListProps,
          children: /*#__PURE__*/_jsx("div", {
            className: classes.menuContainer,
            onClick: keepOpenOnClick ? null : this.handleClose,
            "data-testid": "menu",
            children: children
          })
        })]
      });
    }
  }]);
}(React.Component);
export default withStyles(styles)(Menu);